import {
  LOAD_CHANNEL_CATEGORIES_INIT,
  LOAD_CHANNEL_CATEGORIES_SUCCESS,
  LOAD_CHANNEL_CATEGORIES_ERROR,
  TOGGLE_SHOW_CATEGORIES,
} from '../actions/categories/constants';

const initialState = {
  loading: false,
  categories: [],
  error: null,
  isShowing: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOAD_CHANNEL_CATEGORIES_INIT:
      return {
        ...state,
        loading: true,
        categories: [],
        error: null
      };
    case LOAD_CHANNEL_CATEGORIES_SUCCESS:
      return {
        ...state,
        loading: false,
        categories: action.data,
        error: null,
      };
    case LOAD_CHANNEL_CATEGORIES_ERROR:
      return {
        ...state,
        loading: false,
        categories: [],
        error: action.error,
      };
    case TOGGLE_SHOW_CATEGORIES:
      return {
        ...state,
        isShowing: !state.isShowing,
      };
    default:
      return state;
  }
};
